import script from "./CoursesSelectionList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoursesSelectionList.vue?vue&type=script&setup=true&lang=ts"

import "./CoursesSelectionList.vue?vue&type=style&index=0&id=7d7dd7c4&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/livoapp/LivoFrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d7dd7c4"]])

export default __exports__